import React from "react";
import styles from "../TopService/TopService.module.css";

const Top_Service_api = [
  {
    title: "Services Included in House Cleaning Services:",
    points: [
      "Includes of all Rooms Cleaning, Bathroom Cleaning, Kitchen Cleaning and Balcony Area Cleaning",
      "Ceiling dusting",
      "Fans/Ac dusting & Cleaning",
      "Walls dusting",
      "Window and channel cleaning",
      "Curtain Cleaning, Sofa Cleaning, mattress & carpet vacuuming",
      "Glass Cleaning",
      "All Wooden Furniture, Doors, etc. cleaning and Polishing ",
      "Floor Scrubbing",
      "After removing the fridge, almirah, sofa, and cleaning the floor, the goods will be put back in place",
      "Oil layer on the kitchen wall will be removed by the kitchen cleaner",
      "Water stains, pan stains, or floor stains in the bathroom will be removed",
    ],
  },
  {
    title: "Materials & Equipment's Used In House Cleaning Services:",
    points: [
      "Professional cleaning chemicals",
      "Single-disc floor scrubber/handheld scrubber",
      " Vacuum Cleaner",
      "Microfiber Cloths for dusting",
      " Mops, Scotch Brite / foam or scrubbers.",
      "Ladders, bucket, wiper and mugs etc.",
    ],
  },
  {
    title: "Benefits Of Booking Us For Home Cleaning Services:",
    points: [
      "Best price guarantee: We offer you the best and lowest price offered in the market.",
      "Five Star Rated Experts: Providing you with the top",
      "certified and accomplished practitioners. ",
      "Timely Service: Our specialists are committed to delivering timely services.",
      "100% safe chemicals usage: Our Experts use",
      "environmentally friendly chemicals",
    ],
  },
  {
    title: "Safety Precautions Follows In House Cleaning Services:",
    points: [
      "Minimal touch contact & social distancing",
      "Daily temperature monitoring.",
      "Wearing masks and gloves. ",
      "Regular sanitization of hands.",
      "Compliant of the Aarogaya Setu App.",
    ],
  },
];

// console.log(Top_Service_api);
const TopService = () => {
  return (
    <div className={styles.container}>
      <p className={styles.topservice_heading}>
        Top 10 House Cleaning Service in Delhi NCR :
      </p>
      {Top_Service_api.map((data, index) => {
        return (
          <>
            <h2> {data.title}</h2>
            <div className={styles.pointCard}>
              {data.points.map((point, index) => {
                return (
                  <>
                    <li>
                      {index + 1} : {point}
                    </li>
                  </>
                );
              })}
            </div>
          </>
        );
      })}
    </div>
  );
};

export default TopService;
